(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products-new"] && !Shopify.designMode) return;
  try {
    
  /* No JS needed; hooks preserved for theme scripts (lazyload/quick-buy, etc.) */

  } catch(e) { console.error(e); }
})();
})();
